import {useState, useEffect, useContext, StrictMode} from "react"
import { useForm, useWatch, reset} from "react-hook-form";
import { useEstadoApp } from "../context/EstadoAppContext";
import { useFormContext } from "../context/FormContext";
import { AuthContext } from '../context/authContext';

import { Tabs } from "./Tabs";
import FormA from "./formA";
import FormB_Tramitacion from './formB_Tramitacion';
import FormC_SeguimientoObra from "./formC_SeguimientoObra";
import VisitasObra from './VisitasObra';

import { Input, Label, Button} from "../components/ui"
import { FormProvider } from '../context/FormContext';

import { AREA_RESP_OBRAS, AREA_RESP_MICROCREDITOS, AREA_RESP_INTERVENCION_SOCIAL, AREA_RESP_MEJORAS, AREA_RESP_CAPACITACIONES } from '../constants/config';

// Nombre de la pestaña de seguimiento según el área responsable. Sin área
// seleccionada (o un área sin nombre propio) queda el genérico "SEGUIMIENTO".
const LABEL_TAB_SEGUIMIENTO = {
    [AREA_RESP_OBRAS]: 'SEGUIMIENTO DE OBRA',
    [AREA_RESP_MICROCREDITOS]: 'SEGUIMIENTO DE MICROCRÉDITOS',
    [AREA_RESP_MEJORAS]: 'SEGUIMIENTO DE MEJORAMIENTOS',
    [AREA_RESP_INTERVENCION_SOCIAL]: 'SEGUIMIENTO DE INTERVENCIÓN SOCIAL',
    [AREA_RESP_CAPACITACIONES]: 'SEGUIMIENTO DE CAPACITACIONES',
};

const EditExp = ({
    id_tabla_obras
}) => {     

    const { formA } = useFormContext();
    const { token } = useContext(AuthContext);
    const { datosGenerales = {}} = formA;
    const { area_responsable } = datosGenerales;
    console.log("TEST area_responsable ---->", area_responsable)

    const {estadoAppX, cambiarEstadoApp} = useEstadoApp();

    const items = [
        {
            id: "tab1",
            label: 'CARACTERÍSTICAS GENERALES',
            form: <FormA 
                estadoAppX={estadoAppX}
            />
        },
        {
            id: "tab2",
            label: 'TRAMITACIÓN',
            form: <FormB_Tramitacion />
        },
        {
            id: "tab3",
            label: LABEL_TAB_SEGUIMIENTO[area_responsable] || 'SEGUIMIENTO',
            form: <FormC_SeguimientoObra />
        },
        {
            id: "tab4",
            label: 'VISITAS',
            form: <VisitasObra
                id_tabla_obras={id_tabla_obras}
                obraLabel={`${datosGenerales.id_partido_obra || ''} — ${datosGenerales.nombre_obra || ''}`.replace(/^ — | — $/, '')}
                area_responsable={area_responsable || ''}
                token={token}
            />
        }
    ];

    const handleDownloadPDF = () => {
        cambiarEstadoApp('previewViabilidadTécnica');
    };

    // Informe técnico CON observaciones, disparado desde dentro de la obra (antes
    // solo se podía desde la Tabla de Proyectos). PreviewPDF toma la obra de
    // selectedObra (id, id_partido_obra, area, tipo de subsidio) y trae el resto de
    // la BD, así que le pasamos esos datos del formA de la obra abierta.
    const handlePreviewConObservaciones = () => {
        cambiarEstadoApp('previewInformeTecnicoObservaciones', {
            obra: {
                id: id_tabla_obras,
                id_partido_obra: datosGenerales.id_partido_obra,
                area_responsable: datosGenerales.area_responsable,
                tipo_subsidio: datosGenerales.tipo_subsidio,
            },
        });
    };

    const handleTabChange = (activeItem) => {
        console.log("PUMA Elemento activo:", activeItem);
    };

    return (
        <>
            <StrictMode>
            <Tabs 
                items={items}
                onTabChange={handleTabChange}
                rightContent={
                    <div className="flex items-center gap-2">
                        {/* Informe técnico (sin observaciones): solo Área de Obras / Intervención Social. */}
                        {(area_responsable === AREA_RESP_OBRAS || area_responsable === AREA_RESP_INTERVENCION_SOCIAL) && (
                            <button
                                onClick={handleDownloadPDF}
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                            >
                                <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                    <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                                </svg>
                                Informe técnico
                            </button>
                        )}
                        {/* Informe técnico con observaciones: igual que en la Tabla de Inicio, para
                            TODAS las áreas responsables. Solo obra guardada (PreviewPDF trae por id). */}
                        {id_tabla_obras && (
                            <button
                                onClick={handlePreviewConObservaciones}
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                            >
                                <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                    <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                                </svg>
                                Informe técnico con observaciones
                            </button>
                        )}
                    </div>
                }
            />              
            </StrictMode>
        </>
    );
}

export default EditExp;
